import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const routesManagementReducer = foxGridReducer(gridNames.routesManagement);

export default routesManagementReducer;
